export enum Role {
  NORMAL = 'Normal',
  ADMIN = 'Admin',
  STAFF = 'Staff',
  EMPTY = ''
}
